import { euro } from '../../core/format/currency'
import type { Product } from '../../core/types/catalog'
import type { GiftTier } from '../../data/gifts'

/** Zoveel producten onder "Ook voor jouw huidtype". */
export const RELATED_COUNT = 4
/** Zo lang staat "Toegevoegd" op de knop. */
export const ADDED_FEEDBACK_MS = 2200

/** Andere producten voor hetzelfde huidtype, zonder het product zelf en zonder de "samen met"-producten. */
export function relatedProducts(product: Product, products: Product[]): Product[] {
  return products
    .filter((p) => p.id !== product.id && !product.pairs.includes(p.id) && p.skinTypes.some((s) => product.skinTypes.includes(s)))
    .slice(0, RELATED_COUNT)
}

/** Eén zin onder de knop: wat dit product doet voor het volgende cadeau. */
export function giftHintFor(price: number, giftSubtotal: number, next: GiftTier | null | undefined): string | null {
  if (!next) return null
  const after = giftSubtotal + price
  return after < next.threshold ? `Met dit product nog ${euro(next.threshold - after)} tot ${next.phrase}` : `Hiermee krijg je ${next.phrase} erbij`
}

/** Regel onder "Eenmalig": inhoud en hoe lang het meegaat, anders stap en categorie. */
export function oneOffMeta(p: Product): string {
  const volume = [p.volume, p.usesPerBottle && `gaat ${p.usesPerBottle} mee`].filter(Boolean).join(' · ')
  return volume || [p.step, p.category.toLowerCase()].filter(Boolean).join(' · ')
}

/** Regel onder "Automatisch bijvullen". */
export function refillMeta(p: Product, perks: string): string {
  const rhythm = p.usesPerBottle ? `Bijvullen elke ${p.usesPerBottle.replace('± ', '')}` : 'Op tijd bijgevuld, jij kiest het ritme'
  return `${rhythm} · ${perks.replace(', ', ' · ')}`
}
